// extracted by mini-css-extract-plugin
export default {"section":"_1wDFU","sectionTitle":"_3k9xA","sectionRelay":"_2-7pY","subTitle":"_2_uV2","descriptionContent":"_2LpT0","errorBox":"_1ld4m","errorTitle":"_4b5iP","errorLink":"_1S1lp"};